const CreateInfo = () => {
  return (
    <div>
      {/*
      <div>
        <Label.Root
          className="text-sm font-medium"
          htmlFor="create-question-message"
        >
          Message
        </Label.Root>
        <TextField.Root
          id="create-question-alias"
          placeholder='e.g. "Hey there! I am Hubert..."'
          onChange={(e) => {
            console.log('e', e)
            setText(e.target.value);
          }}
          defaultValue={text}
          size={'3'}
        >
          <TextField.Slot
            side='right'
            pr={"0"}
          >
            <Button
              size="3"
              className='bg-primary'
              onClick={() => {
                updateText(text);
              }}
            >
              Add text
            </Button>
          </TextField.Slot>
        </TextField.Root>
        <span
          className="text-sm font-normal text-gray-500"
        >
          The text the candidate will see.
        </span>
      </div>

      <div>
        {q.text.map((x: string) => {
          return (
            <div>
              {x}
            </div>
          )
        })}
      </div> */}
    </div>
  );
};

export default CreateInfo;
